import { ProjectInfo } from '../components/project/api'
import { MissionResponseData } from '../openapi/api'
import { commonResource } from '../../i18n/common'

export const generateJSTDateString = (): string => {
  return new Date()
    .toLocaleDateString('ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    .replace(/\//g, '')
}

export const generateProjectTitle = async (
  missionInfo: MissionResponseData | undefined,
  isRemix: boolean,
  originalTitle?: string,
  existingProjects?: ProjectInfo[],
): Promise<string> => {
  const dateStr = generateJSTDateString()
  let baseTitle: string

  if (isRemix && originalTitle) {
    baseTitle = `${originalTitle}-${commonResource.to('remix_suffix')}-${dateStr}`
  } else if (missionInfo?.title) {
    baseTitle = `${missionInfo.title}-${dateStr}`
  } else {
    baseTitle = `${commonResource.to('untitled_project')}-${dateStr}`
  }

  if (existingProjects) {
    let finalTitle = baseTitle
    let counter = 1

    while (existingProjects.some((project) => project.title === finalTitle)) {
      finalTitle = `${baseTitle}-${counter}`
      counter++
    }

    return finalTitle
  }

  return baseTitle
}
